import React, { useState, useEffect, createContext } from 'react';
import i18n, { InitOptions } from 'i18next';
import { I18nextProvider, initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locale/en.json';
import de from '../locale/de.json'

const defaultLng = 'en';

interface LanguageContextProperties {
    Locale: string;
}

const LanguageContext = createContext<LanguageContextProperties>({Locale: defaultLng});

const LanguageProvider = (props: React.PropsWithChildren<{ customLocale?: string }>) => {

    const [loading, setLoading] = useState<boolean>(true);
    const [locale, setLocale] = useState<string>(defaultLng);

    useEffect(() => {
        const locale = props.customLocale;

        const options: InitOptions = {
            lng: locale,
            fallbackLng: defaultLng,
            load: 'languageOnly',
            resources: {
                en, de
            },
            interpolation: {
                escapeValue: false // react already safes from xss
            }
        }

        if (!locale) {
            void i18n.use(LanguageDetector).init({
                detection: {
                    order: ['querystring', 'navigator', 'htmlTag', 'cookie', 'localStorage', 'sessionStorage'],
                    lookupQuerystring: 'lng',
                    lookupCookie: 'i18next',
                    lookupLocalStorage: 'i18nextLng',
                    lookupSessionStorage: 'i18nextLng',

                    // cache user language -> cache disabled
                    caches: [],
                    excludeCacheFor: ['cimode'],
                    //cookieMinutes: 10,
                    //cookieDomain: 'myDomain'
                }
            });
        }

        void i18n
            .use(initReactI18next) // bind react-i18next to the instance
            .init(options).then(() => {
                if(i18n.resolvedLanguage) {
                    setLocale(i18n.resolvedLanguage);
                }
                setLoading(false);
            });
    }, [props.customLocale]);

    return (
        loading ?
            <></>
            :
            <I18nextProvider i18n={i18n}>
                <LanguageContext.Provider value={{ Locale: locale }}>
                    {props.children}
                </LanguageContext.Provider>
            </I18nextProvider>
    );
}

export { LanguageProvider, LanguageContext } 